module.exports = "/_next/static/images/yazawa_lunchbox-333daf3dfdafaeb59dd7461acc42d7d7.jpg";